import React, { useState } from 'react';
import Modal from 'react-modal';
import Heading from '../../Components/Heading/Heading';
import './style.scss';

// Assurez-vous de définir la propriété appElement pour la gestion de l'accessibilité (voir documentation react-modal)
Modal.setAppElement('#root');

function Contact() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  // États pour la validation des champs
  const [firstNameValid, setFirstNameValid] = useState(true);
  const [lastNameValid, setLastNameValid] = useState(true);
  const [emailValid, setEmailValid] = useState(true);
  const [subjectValid, setSubjectValid] = useState(true);
  const [messageValid, setMessageValid] = useState(true);

  const [contacts, setContacts] = useState(JSON.parse(localStorage.getItem('data')) ?? []);

  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const handleForm = (e) => {
    e.preventDefault();
    // On Fait la vérification de la validité de tous les champs avant de soumettre
    if (firstNameValid && lastNameValid && emailValid && subjectValid && messageValid) {
      const object = {
        firstName,
        lastName,
        email,
        subject,
        message
      };
      const newArray = [...contacts, object];
      setContacts(newArray);
      
      // Réinitialisation des états après soumission du formulaire
      setFirstName('');
      setLastName('');
      setEmail('');
      setSubject('');
      setMessage('');
      setSuccessModalIsOpen(true);
    } else {
      setModalContent('Veuillez remplir correctement tous les champs.');
      setErrorModalIsOpen(true);
    }
  };

  // Fonction de validation pour le prénom
  const validateFirstName = (value) => {
    const isValid = /^[A-Za-z_]{3,15}$/.test(value);
    setFirstNameValid(isValid);
    return isValid;
  };

  // Fonction de validation pour le nom de famille
  const validateLastName = (value) => {
    const isValid = /^[A-Za-z_]{3,15}$/.test(value);
    setLastNameValid(isValid);
    return isValid;
  };

  // Fonction de validation pour l'email
  const validateEmail = (value) => {
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    setEmailValid(isValid);
    return isValid;
  };

  // Fonction de validation pour le sujet
  const validateSubject = (value) => {
    const isValid = value.trim() !== '';
    setSubjectValid(isValid);
    return isValid;
  };

  // Fonction de validation pour le message
  const validateMessage = (value) => {
    const isValid = value.trim() !== '';
    setMessageValid(isValid);
    return isValid;
  };

  return (
    <div className="App">
      <Heading firstWord="Me" secondWord="Contacter" />

      <form onSubmit={handleForm}>
        
        
        <label htmlFor="lastName">Nom:</label>
        <input
          value={lastName}
          type="text"
          name="lastName"
          id="lastName"
          placeholder="Entrez votre nom"
          onChange={(e) => {
            setLastName(e.target.value);
            validateLastName(e.target.value);
          }}
          className={lastNameValid ? '' : 'invalid'}
        />
        {!lastNameValid && <p className="error-message">Le nom est trop court!</p>}
<label htmlFor="firstName">Prénom:</label>
<input
          value={firstName}
          type="text"
          name="firstName"
          id="firstName"
          placeholder="Entrez votre prénom"
          onChange={(e) => {
            setFirstName(e.target.value);
            validateFirstName(e.target.value);
          }}
          className={firstNameValid ? '' : 'invalid'}
        />
        {!firstNameValid && <p className="error-message">Le prenom est trop court!</p>}

        <label htmlFor="email">Email:</label>
        <input
          value={email}
          type="text"
          name="email"
          id="email"
          onChange={(e) => {
            setEmail(e.target.value);
            validateEmail(e.target.value);
          }}
          placeholder="Entrez votre Email"
          className={emailValid ? '' : 'invalid'}
        />
        {!emailValid && <p className="error-message">Veuillez entrer une adresse email valide!</p>}

        <label htmlFor="subject">Sujet:</label>
        <input
          value={subject}
          type="text"
          name="subject"
          id="subject"
          onChange={(e) => {
            setSubject(e.target.value);
            validateSubject(e.target.value);
          }}
          placeholder="Entrez le sujet de votre message"
          className={subjectValid ? '' : 'invalid'}
        />
        {!subjectValid && <p className="error-message">Veuillez entrer un sujet.</p>}

        <label htmlFor="message">Message:</label>
        <textarea
          value={message}
          name="message"
          id="message"
          cols="10"
          rows="10"
          placeholder="Entrez votre message"
          onChange={(e) => {
            setMessage(e.target.value);
            validateMessage(e.target.value);
          }}
          className={messageValid ? '' : 'invalid'}
        ></textarea>
        {!messageValid && <p className="error-message">Veuillez entrer un message.</p>}

        <button type="submit">Envoyer</button>
      </form>

      <Modal
        isOpen={errorModalIsOpen}
        onRequestClose={() => setErrorModalIsOpen(false)}
        className="custom-modal"
        overlayClassName="overlay"
      >
        <div className="modal-content">
          <h2>Veuillez remplir le formulaire correctement</h2>
          <p>{modalContent}</p>
          <button onClick={() => setErrorModalIsOpen(false)}>Fermer</button>
        </div>
      </Modal>

      <Modal
        isOpen={successModalIsOpen}
        onRequestClose={() => setSuccessModalIsOpen(false)}
        className="custom-modal"
        overlayClassName="overlay"
      >
        <div className="modal-content">
          <h2>Votre formulaire a été envoyé avec succès.</h2>
          <p>Succès</p>
          <button onClick={() => setSuccessModalIsOpen(false)}>Fermer</button>
        </div>
      </Modal>
    </div>
  );
}

export default Contact;